import React from 'react';
import PropTypes from 'prop-types';
import Row from 'react-bootstrap/Row';

const DLPButton = ({ redirect }) => (
  <Row className="justify-content-md-center">
    <div className="button button-icon justify-content-md-center mb-5 block text-center">
      <a
        className="center-text"
        href="https://thepantry--simpplr.visualforce.com/apex/simpplr__app?u=/site/a144W00000YKFwNQAX/page/a124W00000N51t7QAB"
        target="_blank"
        rel="noopener noreferrer nofollow"
      >
        Read Data Classification Policy <i className="fa fa-angle-right" aria-hidden="true"></i>
      </a>
    </div>
    <div className="button button-icon mb-5">
      <a className="text-center" href={redirect} target="_blank" rel="noopener noreferrer nofollow">
        Open a Service Request <i className="fa fa-angle-right" aria-hidden="true"></i>
      </a>
    </div>
  </Row>
);

DLPButton.propTypes = {
  category: PropTypes.string,
  url: PropTypes.string,
  zsq: PropTypes.string,
  redirect: PropTypes.string,
};

export default DLPButton;
